module.exports = __webpack_public_path__ + "img/di18.ca21983e.png";